import { useState } from 'react';
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import
import type {
  IWizardState,
  IUseCreateTypeWizardResult,
  TStartingSource,
} from '@/@types/insuranceBuilder';

const INITIAL_STATE: IWizardState = {
  providerId: undefined,
  name: '',
  source: 'blank',
  copyFromId: undefined,
  submitting: false,
};

export function useCreateTypeWizard(): IUseCreateTypeWizardResult {
  const [state, setState] = useState<IWizardState>(INITIAL_STATE);

  const setProviderId = (id: Id<'insuranceProviders'> | undefined) =>
    setState(s => ({ ...s, providerId: id }));

  const setName = (name: string) => setState(s => ({ ...s, name }));

  const setSource = (source: TStartingSource) =>
    setState(s => ({ ...s, source, copyFromId: source === 'copy' ? s.copyFromId : undefined }));

  const setCopyFromId = (id: Id<'orgInsuranceTypes'> | undefined) =>
    setState(s => ({ ...s, copyFromId: id }));

  const setSubmitting = (submitting: boolean) => setState(s => ({ ...s, submitting }));

  return { state, setProviderId, setName, setSource, setCopyFromId, setSubmitting };
}
